// extracted by mini-css-extract-plugin
module.exports = {"header":"about_header__3IvhD","about_content":"about_about_content__2J6hh"};